
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = new Model({
	name: "callgroups",
	init: init,
	uninit: uninit,
	listeners: listeners,

	refresh: refresh,
	addPerson: addPerson,
	addPeople: addPeople,
	trackGroup: trackGroup,
	trackGroups: trackGroups,
	untrackGroup: untrackGroup
});

function listeners(){
	return {
		"connectivity:online": refresh,
		"orggroup:updated": handle_org_group_update
	};
}

function init(){
	this._group = "";
	this._groups = [];
	this._group_tracker = this.dispatcher.createTracker();
	this.push([]);
	this.refresh();
}

function uninit(){
	this._groups = null;
	this._group_tracker.off();
	this._group_tracker = null;
}

function addPeople(){
	var groups = this._groups;
	groups.forEach(function(group){
		var members = group.members;
		this.addPerson(members);
	}.bind(this));
}

function addPerson(who){
	this.emit("people:trigger:add", {
		who: who,
		lean: true
	});
	this.emit("incall:trigger:add", {
		who: who
	});
}

function refresh(){
	return this.api.callgroups.list()
		.then(setGroups.bind(this));
}

function setGroups(groups){
	this._groups = groups;
	this.addPeople();
	this.push(groups);
}

function trackGroups(){
	var orgGroup = this._group;
	var groups = this._groups;
	var tracker = this._group_tracker;
	if(!orgGroup) return;

	tracker.off();
	groups.forEach(trackGroup.bind(this));
	tracker.on("mqtt:orggroup/" + orgGroup + "/callgroups/created", handle_group_created.bind(this));
}

function trackGroup(group){
	var orgGroup = this._group;
	var tracker = this._group_tracker;
	var prefix = "mqtt:orggroup/" + orgGroup + "/callgroups/" + group._id;

	this.untrackGroup(group._id);
	tracker.on(prefix + "/members/added", handle_member_added.bind(this));
	tracker.on(prefix + "/members/removed", handle_member_removed.bind(this));
	tracker.on(prefix + "/updated", handle_group_updated.bind(this));
	tracker.on(prefix + "/removed", handle_group_removed.bind(this));
}

function untrackGroup(group){
	var orgGroup = this._group;
	var tracker = this._group_tracker;
	var prefix = "mqtt:orggroup/" + orgGroup + "/callgroups/" + group;

	tracker.off(prefix + "/members/added");
	tracker.off(prefix + "/members/removed");
	tracker.off(prefix + "/updated");
	tracker.off(prefix + "/removed");
}

function handle_member_added(data){
	var groups = this._groups;
	var id = data.group;
	var who = data.who;

	this.addPerson(who);
	var newGroups = groups.map(function(group){
		if(group._id === id){
			var newMembers = group.members.concat(who);
			return xtend(group, {
				members: newMembers
			});
		}
		return group;
	});

	this._groups = newGroups;
	this.push(newGroups);
}

function handle_member_removed(data){
	var groups = this._groups;
	var id = data.group;
	var who = data.who;

	var newGroups = groups.map(function(group){
		if(group._id === id){
			var newMembers = group.members.filter(function(member){
				return member !== who;
			});
			return xtend(group, {
				members: newMembers
			});
		}
		return group;
	});

	this._groups = newGroups;
	this.push(newGroups);
}


function handle_group_updated(data){
	var groups = this._groups;
	var groupId = data.group;

	var newGroups = groups.map(function(group){
		if(group._id === groupId){
			return xtend(group, data);
		}
		return group;
	});

	this._groups = newGroups;
	this.push(newGroups);
}

function handle_group_removed(data){
	var groups = this._groups;
	var groupId = data.group;

	var newGroups = groups.filter(function(group){
		return groupId !== group._id;
	});

	this._groups = newGroups;
	this.untrackGroup(groupId);
	this.push(newGroups);
}

function handle_group_created(group){
	var groups = this._groups;

	var newGroups = groups.concat(group);

	this._groups = newGroups;
	this.trackGroup(group);
	this.push(newGroups);
}

function handle_org_group_update(group){
	this._group = group;
	this.trackGroups();
}